import React from "react";
import { Link, useMatches } from "react-router-dom";

const Breadcrumbs = () => {
  const matches = useMatches();
  // Filter matches with a defined breadcrumb handle
  const crumbs = matches.filter((match) => match.handle?.breadcrumb);

  // Don't render if there's only one breadcrumb
  if (crumbs.length <= 1) {
    return null;
  }

  return (
    <div className="mb-4 bg-gray-300">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          {crumbs.map((match, index) => {
            const { breadcrumb, breadcrumbLinkTitle } = match.handle;
            const isActive = index + 1 === crumbs.length;

            return (
              <li
                key={match.pathname}
                className={`breadcrumb-item ${
                  isActive ? "active font-weight-bold" : ""
                }`}
                aria-current={isActive ? "page" : undefined}
              >
                {isActive ? (
                  <span className="text-tertiary">
                    {breadcrumb({ match, isActive })}
                  </span>
                ) : (
                  <Link
                    to={match.pathname}
                    className="text-decoration-none text-light"
                    title={
                      breadcrumbLinkTitle || breadcrumb({ match, isActive })
                    }
                  >
                    {breadcrumb({ match, isActive })}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumbs;
